import {
  getObject,
  getString,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "./code";

export interface AnswerDTO {
  code: CodeDTO;
  answer: string;
}

export class Answer {
  readonly isAnswerAnswer: boolean = true;

  readonly code: Code;
  readonly answer: string;


  constructor(
  code: Code, 
  answer: string
  ) {
    this.code = code;
    Answer.validateAnswer(answer);
    this.answer = answer;
  }

  static fromDTO(dto: AnswerDTO): Answer {
    const code = Code.fromDTO(getObject(dto, "code", InvalidAnswerCodeError));
    const answer = getString(dto, "answer", InvalidAnswerAnswerError);
    return new Answer(
      code,
      answer
    );
  }

  toDTO(): AnswerDTO {
    const dto: AnswerDTO = {
        code: this.code.toDTO(),
        answer: this.answer
    };
    return dto;
  }
  private static validateAnswer = (answer: string): void => {
    if(answer.trim().length === 0) {
      throw new InvalidAnswerAnswerNonEmptyError(
        `Attribute answer cannot be an empty string.`
      );
    }
  }
  
}

Answer.prototype.toString = function toString(): string {
  return `Answer(code='${this.code}',answer='${this.answer}')`;
};

export class InvalidAnswerError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAnswerError";
  }
}
export class InvalidAnswerCodeError extends InvalidAnswerError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAnswerCodeError";
  }
}

export class InvalidAnswerAnswerError extends InvalidAnswerError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAnswerAnswerError";
  }
}

export class InvalidAnswerAnswerNonEmptyError extends InvalidAnswerAnswerError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidAnswerAnswerNonEmptyError";
  }
}
